export default __webpack_public_path__ + "static/media/img_major04_2.56c4d480.jpg";